import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import { catchError, concatMap, endWith, flatMap, map, mergeAll, mergeMap, startWith, switchMap, take } from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

/**
 * @category `Api lấy biểu đồ chi phí vận hành phương tiện`
 * @description: **Write your description**
 * @detail detail
 * @params ` param`:  param type
 * @return return type (void, boolean, int, string, object, array,...)  and write logs
 * @example input => output
 * @author:  alogobay 09:42:52 2020-06-11
 */
const getBieuDo1 = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_ACTIVITY_TRANSPORTATION_BY_PARAMS),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const isLogin = Object.keys(state$.value.account).length
            if (isLogin) {
               // BIỂU ĐỒ 1 và BIỂU ĐỒ 2
               // Gọi api biểu đồ chi phí vận hành phương tiện
               const graphPriceActivity = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.F_DASHBOARD.GRAPH_PRICE_ACTIVITY_TRANSPORTATION}?option_vehicle=${action.payload.filterPT}&option_time=${action.payload.time}&option_fee=${action.payload.type}&option_sort=${action.payload.sort}`
               )
               // Cập nhật biểu đồ chi phí vận hành phương tiện vào dashboard reducer
               arrayAction.push(
                  CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_ACTIVITY_TRANSPORTATION, graphPriceActivity.data.data)
               )
            }
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(of(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.AUTHORIZATION, true)), from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

/**
 * @category `API lấy biểu đồ hoạt động của phương tiện`
 */
const getBieuDo4 = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_ACTIVITY_TRANSPORTATION_BY_PARAMS),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const isLogin = Object.keys(state$.value.account).length
            if (isLogin) {
               // BIỂU ĐỒ 4
               // Gọi api biểu đồ hoạt động phương tiện
               const graphActivityTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.F_DASHBOARD.GRAPH_ACTIVITY_TRANSPORTATION}?option_vehicle=${action.payload.filterPT}&option_time=${action.payload.time}&option_view=${action.payload.trangThaiHoatDong}`
               )
               // Cập nhật thông tin thống kê lịch nhắc vào dashboard reducer
               arrayAction.push(
                  CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_ACTIVITY_TRANSPORTATION, graphActivityTransportation.data.data)
               )
            }
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(of(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.AUTHORIZATION, true)), from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

/**
 * @category `API lấy biểu đồ thống kê lịch nhắc theo thời gian`
 */
const getGraphPriceTimeTransportationByTime = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_TIME_TRANSPORTATION_BY_TIME),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            const graphPriceTime = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.F_DASHBOARD.GRAPH_PRICE_TIME_TRANSPORTATION}?option_time=${action.payload}`
            )
            // Cập nhật thông tin thống kê lịch nhắc vào dashboard reducer
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_TIME_TRANSPORTATION, graphPriceTime.data.data))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(of(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.AUTHORIZATION, true)), from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

/**
 * @category `API lấy thống kê lịch nhắc theo thời gian`
 */
const getStatisticalReminderByTime = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.F_DASHBOARD.STATISTICAL_REMINDER_BY_TIME),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            // Gọi api thống kê lịch nhắc
            const statisticalReminder = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.F_DASHBOARD.STATISTICAL_REMINDER}?type=${action.payload}`)
            // Cập nhật thông tin thống kê lịch nhắc vào dashboard reducer
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.STATISTICAL_REMINDER, statisticalReminder.data.data))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(of(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.AUTHORIZATION, true)), from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// code của mr Đạt (có 2 hướng giải quyết: 1 là front-end tự add data mảng rỗng khi is_staff là admin,2 là nhờ backend trả về data mảng rỗng khi is_staff là "admin")
const setAccountEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ACCOUNT.SET_ACCOUNT),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const accountInfo = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.ACCOUNT.GET)
            if (!accountInfo.status) {
               CONSTANTS.FUNCTION.COMMON.clearStorage()
               window.location.href = "/"
               // window.location.href = "/baoduong2"
            }
            // Sau khi login chuyển màn hình về trang dashboard
            // arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.IS_SHOW_FDASHBOARD, true))
            // Điều chỉnh hiển thị các thông tin account
            accountInfo.data.data.username = accountInfo.data.data.user_name
            delete accountInfo.data.data.user_name
            delete accountInfo.data.data.password
            // Lấy danh sách users có thể chuyển vào state account
            // Cập nhật thông tin tài khoản cho state redux
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.ACCOUNT.UPDATE_ACCOUNT, accountInfo.data.data))

            if (parseInt(accountInfo.data.data.is_staff) === 1) {
               // Cập nhật thông tin danh sách user có thể chuyển đổi vào state account cho state redux
               arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.ACCOUNT.GET_USERS_TRANSFERANCE))
            }
            const transportations = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.TRANSPORTATION.GET_ALL}?page=1`)

            const documentConfig = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.GET_REMINDER_DOCUMENT_CONFIG}?page=1`
            )

            const maintananceConfig = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.GET_REMINDER_MAINTANANCE_CONFIG}?page=1`
            )
            // Gọi api thống kê danh sách phương tiện => cung cấp dữ liệu cho màn hình dashboard
            const statisticalTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.F_DASHBOARD.STATISTICAL_TRANSPORTATION}`)
            // Cập nhật thông tin thông kê danh sách phương tiện vào reducer
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.STATISTICAL_TRANSPORTATION, statisticalTransportation.data.data))

            // Gọi api thống kê lịch nhắc
            const statisticalReminder = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.F_DASHBOARD.STATISTICAL_REMINDER}?type=1`)
            // Cập nhật thông tin thống kê lịch nhắc vào dashboard reducer
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.STATISTICAL_REMINDER, statisticalReminder.data.data))

            // Gọi api thông báo hoạt động của phương tiện
            const alertActivityTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.F_DASHBOARD.ACTIVITY_TRANSPORTATION}`)
            // Cập nhật thông tin thống kê lịch nhắc vào dashboard reducer
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.ACTIVITY_TRANSPORTATION, alertActivityTransportation.data.data))

            // Start load các biểu đồ theo mặc định, các trường hợp load theo danh sách tham số được gọi ở action tương ứng
            // BIỂU ĐỒ 1 và BIỂU ĐỒ 2
            // Gọi api biểu đồ chi phí vận hành phương tiện
            const graphPriceActivity = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.F_DASHBOARD.GRAPH_PRICE_ACTIVITY_TRANSPORTATION}?option_vehicle=vh_20&option_time=1&option_fee=0&option_sort=0`
            )
            // Cập nhật biểu đồ chi phí vận hành phương tiện vào dashboard reducer
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_ACTIVITY_TRANSPORTATION, graphPriceActivity.data.data))

            // BIỂU ĐỒ 3
            // Mặc định lấy dự liệu biểu đồ theo 3 tháng option_time=1
            const graphPriceTime = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.F_DASHBOARD.GRAPH_PRICE_TIME_TRANSPORTATION}?option_time=1`)
            // Cập nhật thông tin thống kê lịch nhắc vào dashboard reducer
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_TIME_TRANSPORTATION, graphPriceTime.data.data))

            // BIỂU ĐỒ 4
            // Gọi api biểu đồ hoạt động phương tiện
            const graphActivityTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.F_DASHBOARD.GRAPH_ACTIVITY_TRANSPORTATION}?option_vehicle=vh_20&option_time=1&option_view=0`
            )
            // Cập nhật thông tin thống kê lịch nhắc vào dashboard reducer
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.F_DASHBOARD.GRAPH_ACTIVITY_TRANSPORTATION, graphActivityTransportation.data.data)
            )
            // End load các biểu đổ

            // Cập nhật danh sách phương tiện của tài khoản cho state redux
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.GET_ALL_TRANSPORTATION_OF_ACCOUNT, transportations.data))

            // Cập nhật cấu hình lịch nhắc hồ sơ giấy tờ cho state redux
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(
                  CONSTANTS.ACTION.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.GET_REMINDER_DOCUMENT_CONFIG,
                  documentConfig.data.data
               )
            )
            // Cập nhật cấu hình lịch nhắc bảo dưỡng cho state redux
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(
                  CONSTANTS.ACTION.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.GET_REMINDER_MAINTANANCE_CONFIG,
                  maintananceConfig.data.data
               )
            )

            if (transportations.data.data.length)
               arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.SET_CURRENT_TRANSPORTATION, transportations.data.data[0]))
			
			// get phụ tùng type & data
			const loaiPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_TYPE_PHU_TUNG)
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_TYPE_PHU_TUNG, loaiPhuTung.data.data))
			
			const danhSachPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG)
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data.data))
			
			// get tires
			const tirePhuongtien = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TIRE.GET_LIST_PHUONGTIEN)
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TIRE.SET_LIST_PHUONGTIEN, tirePhuongtien.data.data))
			
			return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(of(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.AUTHORIZATION, true)), from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

/**
 * @category `Cập nhật danh sách user có thể chuyển đổi phần admin bar right`
 */
const updateUsersTransferance = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ACCOUNT.GET_USERS_TRANSFERANCE),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            // Lấy danh sách user có thể chuyển đổi
            const usersTranferance = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.ACCOUNT.GET_USERS_TRANSFERANCE)

            // Lấy danh sách users có thể chuyển vào state account
            // Cập nhật thông tin tài khoản cho state redux
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.ACCOUNT.UPDATE_ACCOUNT, { usersTranferance: usersTranferance.data.data }))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

/**
 * @category `Lấy danh sách user có thể chuyển đổi phần admin bar right`
 */
const transferUser = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ACCOUNT.TRANSFER_USER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            // Lấy danh sách user có thể chuyển đổi
            const tokenTransferanceUser = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.AUTH.TRANSFER_USER}?transfer_account=${action.payload}`)
            // Lưu token vào localStorage
            CONSTANTS.FUNCTION.COMMON.updateTokenStorage(tokenTransferanceUser.data.data.token)
            // Lấy danh sách users có thể chuyển vào state account
            // Cập nhật thông tin tài khoản cho state redux
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.ACCOUNT.SET_ACCOUNT))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

export default {
   getBieuDo1,
   getBieuDo4,
   getGraphPriceTimeTransportationByTime,
   getStatisticalReminderByTime,
   setAccountEpic,
   updateUsersTransferance,
   transferUser
}
